/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} You_HaveInputs */

const en_you_have = /** @type {(inputs: You_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have`)
};

const ar_you_have = /** @type {(inputs: You_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const de_you_have = /** @type {(inputs: You_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const es_you_have = /** @type {(inputs: You_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const fr_you_have = /** @type {(inputs: You_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const it_you_have = /** @type {(inputs: You_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ja_you_have = /** @type {(inputs: You_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ko_you_have = /** @type {(inputs: You_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const pt_br_you_have = /** @type {(inputs: You_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ru_you_have = /** @type {(inputs: You_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const th_you_have = /** @type {(inputs: You_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const tr_you_have = /** @type {(inputs: You_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const zh_cn_you_have = /** @type {(inputs: You_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const zh_tw_you_have = /** @type {(inputs: You_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你目前有`)
};

/**
* | output |
* | --- |
* | "You have" |
*
* @param {You_HaveInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const you_have = /** @type {((inputs?: You_HaveInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<You_HaveInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_you_have(inputs)
	if (locale === "ar") return ar_you_have(inputs)
	if (locale === "de") return de_you_have(inputs)
	if (locale === "es") return es_you_have(inputs)
	if (locale === "fr") return fr_you_have(inputs)
	if (locale === "it") return it_you_have(inputs)
	if (locale === "ja") return ja_you_have(inputs)
	if (locale === "ko") return ko_you_have(inputs)
	if (locale === "pt_br") return pt_br_you_have(inputs)
	if (locale === "ru") return ru_you_have(inputs)
	if (locale === "th") return th_you_have(inputs)
	if (locale === "tr") return tr_you_have(inputs)
	if (locale === "zh_cn") return zh_cn_you_have(inputs)
	return zh_tw_you_have(inputs)
});